<template>
  <div class="login-container">
    <div @click="home" class="close">
      <CloseIcon />
      <span class="close-text">ESC</span>
    </div>
    <LogoTile @click="home" />
    <span class="title">Welcome back</span>
    <div class="subtitle">
      First time here?
      <router-link :to="{ name: 'Signup' }" class="white-link" tabindex="0"
        ><span>Sign up</span></router-link
      >.
    </div>
    <div class="login-content">
      <div class="inputs">
        <div class="floating-label has-icon">
          <input
            v-model="email"
            placeholder="Please enter your email"
            type="email"
            name="email"
            id="email"
            autofocus
            autocomplete="off"
            @keyup.enter="handleEnter"
          />
          <label for="email">Email</label>
          <div class="input-icon">
            <MailIcon class="icon mini" />
          </div>
        </div>
        <div class="floating-label has-icon">
          <input
            v-model="password"
            placeholder="Please enter your password"
            type="password"
            name="password"
            id="password"
            tabindex="0"
            autocomplete="off"
            @keyup.enter="handleEnter"
          />
          <label for="password">Password</label>
          <div class="input-icon">
            <PasswordIcon class="icon small" />
          </div>
        </div>
      </div>
      <button
        @click="login"
        class="button-default big login-button"
        :disabled="!email || !password || loading"
        tabindex="0"
      >
        <span>{{ loading ? "Loading..." : "Log In" }}</span>
      </button>
      <div class="forgot">
        <router-link
          :to="{ name: 'ForgotPassword' }"
          class="white-link"
          tabindex="0"
        >
          <span>Forgot password?</span>
        </router-link>
      </div>
    </div>
    <SnackBar>
      <template v-slot:icon>
        <ErrorIcon />
      </template>
    </SnackBar>
  </div>
</template>
<script>
import LogoTile from "@/components/LogoTile";
import CloseIcon from "../../../../public/img/icons/close.svg";
import MailIcon from "@/assets/img/svg/mail.svg";
import PasswordIcon from "../../../../public/img/icons/password.svg";
import ErrorIcon from "../../../../public/img/icons/error.svg";
import { M_LOGIN } from "@/graphql";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  components: {
    LogoTile,
    CloseIcon,
    MailIcon,
    PasswordIcon,
    ErrorIcon,
    SnackBar,
  },
  name: "Login",
  props: ["existing_email"],
  data() {
    return {
      email: null,
      password: null,
      loading: false,
    };
  },
  async mounted() {
    if (this.existing_email) {
      this.email = this.existing_email;
      await this.$store.dispatch("snack", {
        text: "Email already registered. Log in to continue",
      });
    }
  },
  methods: {
    async login() {
      this.loading = true;
      const { email, password } = this;
      try {
        const result = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_LOGIN,
          variables: {
            email: email,
            password: password,
          },
        });
        const user = result.data.login.user;
        console.warn("USER", user);
        localStorage.setItem("token", result.data.login.token);
        await this.$store.dispatch("setUser", user);
        await this.$store.dispatch("setArtist", { ...user.artists[0] });

        await this.$store.dispatch(
          "setArtistPhoneNumbers",
          user.artists[0]?.phone_numbers
        );
        // reset state
        this.$store.commit("resetSnack");
        this.$store.commit("resetCreateLinkWizardData");
        this.$store.commit("resetEditLinkWizardData");
        this.$store.commit("addArtist/reset");
        this.$store.commit("signup/reset");
        // signup stuff if they need to complete it
        if (user.signup_step && user.signup_step < 11) {
          this.$store.commit("signup/setStep", user.signup_step);
          this.$store.commit("signup/setId", user.id);
          this.$store.commit("signup/setEmail", user.email);
          this.$store.commit("signup/setEmailPending", user.email_pending);
          this.$store.commit("signup/setName", {
            firstname: user.firstname,
            lastname: user.lastname,
          });
          this.$store.commit("signup/setArtists", user.artists);
          document.location = "signup";
        } else {
          this.loading = false;
          document.location = "links";
          // await this.$router.push({ name: "SmartLinks" });
        }
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: err.message.replace("GraphQL error: ", ""),
        });
        this.loading = false;
      }
    },
    handleEnter() {
      if (!this.email || !this.password || this.loading) {
        return;
      } else {
        this.login();
      }
    },
    async home() {
      await this.$router.push({ name: "Homepage" });
    },
  },
  computed: {
    couponApplied() {
      return !!this.$cookies.get("coupon");
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  /* BG/type2 */
  background: #1b193c;
  background: radial-gradient(
    circle,
    rgba(27, 25, 60, 1) 0%,
    rgba(11, 12, 20, 1) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &.coupon-applied {
    height: calc(100vh - 62px);
    .close {
      top: 86px;
    }
  }
  .close {
    cursor: pointer;
    position: fixed;
    top: 44px;
    right: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:hover {
      svg {
        path {
          fill: white;
        }
      }
      .close-text {
        color: white;
      }
    }
    svg {
      width: 18px;
      margin: 3px 0;
      path {
        fill: #8786ab;
      }
    }
    .close-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 10px;
      text-transform: uppercase;
      /* Text/type2 */
      color: $text-type-2;
    }
  }
  .logo-icon {
    width: 54px;
  }
  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    .inputs {
      margin-top: 30px;
      width: 100%;
      display: grid;
      grid-gap: 18px;
    }
    .forgot {
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .login-button {
      margin-top: 22px;
      width: 100%;
    }
    .sign-up {
      margin-top: 69px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .signup-text {
        margin-bottom: 10px;
        /* 16/Regular */
        font-size: 16px;
        line-height: 24px;
        /* Text/type0 */
        color: $text-type-0;
      }
    }
  }
  .white-link {
    color: #fff;
    cursor: pointer;
  }
}
</style>
